// ...existing code...
import React from 'react';
import {Box, Typography, Paper} from '@mui/material';
import './ProgressLoader.scss';
import {t} from 'i18next';

type ProgressLoaderProps = {
  status?: string;
  progressPercent?: number;
  updatedDocs?: number | string;
  segments?: number;
  showProgressbarOnly?: boolean;
  ariaLabel?: string;
};

const ProgressLoader: React.FC<ProgressLoaderProps> = ({
  status = '',
  progressPercent = 0,
  updatedDocs = 0,
  segments = 100,
  showProgressbarOnly,
  ariaLabel,
}) => {
  const filledSegments = Math.round(
    (segments * Math.max(0, Math.min(100, progressPercent))) / 100
  );

  const isFailure = /fail|error/i.test(String(status ?? ''));
  return (
    <div className="apo-progress-card" data-status={status}>
      {!showProgressbarOnly && (
        <Box className="apo-progress-box" mb={1} data-testid="progress-box">
          <Box data-testid="progress-title-wrapper">
            <Typography
              variant="subtitle1"
              className="apo-progress-title"
              data-testid="progress-title"
            >
              {t('ingestions.mapped.ingestionApo.progressUpdate')}
            </Typography>
            <Typography
              variant="body2"
              data-testid="progress-status"
              className="apo-progressStatus"
            >
              {t('ingestions.mapped.ingestionApo.progressStatus')}: {status}
            </Typography>
          </Box>

          <Box textAlign="right" data-testid="progress-updated-docs-wrapper">
            <Typography
              variant="body2"
              className="apo-updated-docs"
              data-testid="progress-updated-docs"
            >
              {t('ingestions.mapped.ingestionApo.progressUpdatedDocument')}:{' '}
              {updatedDocs}
            </Typography>
          </Box>
        </Box>
      )}

      <Box
        className={`apo-progress-bar ${isFailure ? 'failure' : ''}`}
        role="progressbar"
        aria-valuenow={progressPercent}
        aria-label={ariaLabel}
        data-testid="progress-bar-box"
      >
        <div
          className={`apo-progress-fill ${isFailure ? 'failure' : ''}`}
          style={{width: `${progressPercent}%`}}
          data-testid="progress-fill"
        />

        {Array.from({length: segments}).map((_, i) => (
          <span
            key={i}
            className="apo-progress-segment"
            data-testid={`progress-segment-${i}`}
            style={{width: `${100 / segments}%`}}
          />
        ))}
      </Box>

      {status === 'Failure' && (
        <Typography variant="body2" data-testid="progress-message">
          {t('ingestions.mapped.ingestionApo.progressFailedStatus')}
        </Typography>
      )}
    </div>
  );
};

export default ProgressLoader;
